import script from "./ResetPasswordView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResetPasswordView.vue?vue&type=script&setup=true&lang=ts"

import "./ResetPasswordView.vue?vue&type=style&index=0&id=bfd4c802&lang=css"

const __exports__ = script;

export default __exports__